import ErrorPage from 'next/error';
import { useRouter } from 'next/router';
import { docBySlugQuery, docSlugsQuery, navigationQuery } from '@lib/queries';
import { usePreviewSubscription } from '@lib/sanity';
import { getClient, sanityClient } from '@lib/sanity.server';
import { guidesIndexQueryProduction } from '@lib/queries';
import { DOCS_URLS } from '@lib';
import { DocsOverview } from '@components';

export default function DocsPage({ data, preview, guides, navigation }: any) {
  const router = useRouter();

  const { slug } = data;
  const { data: docData } = usePreviewSubscription(docBySlugQuery, {
    params: { slug },
    initialData: data,
    enabled: preview && slug
  });

  if (!data || (!router.isFallback && !data.slug)) {
    return <ErrorPage statusCode={404} />;
  }

  return router.isFallback ? (
    <div>Loading...</div>
  ) : (
    <DocsOverview
      data={docData}
      guides={guides}
      query={router.query}
      navigation={navigation}
    />
  );
}

export async function getStaticProps({ params, preview = false }: any) {
  const [data, guides, navigation] = await Promise.all([
    getClient(preview).fetch(docBySlugQuery, {
      // Slug query requires full path including category
      slug: `/docs/${params.category}/overview`
    }),
    getClient(preview).fetch(guidesIndexQueryProduction),
    getClient(preview).fetch(navigationQuery)
  ]);

  // Set SEO prop from data
  return {
    props: {
      seo: data?.seo || null,
      data,
      preview,
      guides,
      navigation
    }
  };
}

export async function getStaticPaths() {
  const paths = await sanityClient.fetch(docSlugsQuery);
  const allowedPaths = paths.filter((path: any) => {
    const overviewPaths = [
      DOCS_URLS.quickstarts,
      DOCS_URLS.integrations,
      DOCS_URLS.apiReference,
      DOCS_URLS.componentReference
    ];

    return path !== '/docs' && overviewPaths.includes(path);
  });

  return {
    paths: allowedPaths,
    fallback: false
  };
}
